import * as moment from 'moment';

import { DateTimeConverter } from 'src/app/core/services/mapper/converters';

export class Jwt {
    static jsonMap = {
        token: 'token',
        refreshToken: 'refreshToken',
        tokenTTL: { key: 'tokenTTL', converter: new DateTimeConverter() },
        refreshTokenTTL: { key: 'refreshTokenTTL', converter: new DateTimeConverter() },
        type: 'type',
        roles: 'roles',
        idIntervenant: 'idIntervenant',
        mailIntervenant: 'mailIntervenant',
        idPortail: 'idPortail',
        codePortail: 'codePortail'
    };

    token: string = undefined;
    refreshToken: string = undefined;
    tokenTTL: moment.Moment = undefined;
    refreshTokenTTL: moment.Moment = undefined;
    type: string = undefined;
    roles: string[] = [];
    idIntervenant: number = undefined;
    mailIntervenant: string = undefined;
    idPortail: number = undefined;
    codePortail: string = undefined;
}
